import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/top',
      name: 'top',
      meta: { requiresAuth: true },
      component: () => import('../views/Top.vue')
    },
    {
      path: '/month',
      name: 'month',
      meta: { requiresAuth: true },
      component: () => import('../views/Shift.vue')
    },
    {
      path: '/week',
      name: 'week',
      meta: { requiresAuth: true },
      component: () => import('../views/Week.vue')
    },
    {
      path: '/usermente',
      name: 'usermente',
      meta: { requiresAuth: true },
      component: () => import('../views/Usermente.vue')
    },
    {
      path: '/staffmente',
      name: 'staffmente',
      meta: { requiresAuth: true },
      component: () => import('../views/Staffmente.vue')
    },
    {
      path: '/loginmente',
      name: 'loginmente',
      meta: { requiresAuth: true },
      component: () => import('../views/Loginmente.vue')
    },
    {
      path: '/kiroku',
      name: 'kiroku',
      meta: { requiresAuth: true },
      component: () => import('../views/Kiroku.vue')
    },
    {
      path: '/jisseki',
      name: 'jisseki',
      meta: { requiresAuth: true },
      component: () => import('../views/Jisseki.vue')
    },
    {
      path: '/logs',
      name: 'logs',
      meta: { requiresAuth: true },
      component: () => import('../views/Logs.vue')
    },
    {
      path: '/pass',
      name: 'pass',
      meta: { requiresAuth: true },
      component: () => import('../views/Pass.vue')
    },
    {
      path: '/kprint',
      name: 'kprint',
      meta: { requiresAuth: true },
      component: () => import('../views/Kprint.vue')
    },
    {
      path: '/jprint',
      name: 'jprint',
      meta: { requiresAuth: true },
      component: () => import('../views/Jprint.vue')
    },
    {
      path: '/infoline',
      name: 'infoline',
      meta: { requiresAuth: true },
      component: () => import('../views/Infoline.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath,
          message: true
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
